module.exports = __webpack_public_path__ + "img/icon_company_verified_animated.adf7595f.gif";